import { render, staticRenderFns } from "./TimeshiftChannel.vue?vue&type=template&id=58703533&scoped=true&"
import script from "./TimeshiftChannel.vue?vue&type=script&lang=js&"
export * from "./TimeshiftChannel.vue?vue&type=script&lang=js&"
import style0 from "./TimeshiftChannel.vue?vue&type=style&index=0&id=58703533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58703533",
  null
  
)

export default component.exports